import { Code, Table } from '@mantine/core'
import { FormattedMessage } from 'react-intl'
import { CopyableText } from '@/components/ui-shared/CopyableText/CopyableText'
import { AiBridge } from '@/types/aiBridge'
import { getFormattedDateWithTime } from '@/utils/date'
import { AiBridgeLastOperation } from '../AiBridgeLastOperation'
import { AiBridgeOperation } from '../useAiBridgeOperationLog'

type AiBridgeInfoProps = {
  aiBridge: AiBridge
  deviceName?: string
  lastOperation?: AiBridgeOperation
}

export const AiBridgeInfo = ({
  aiBridge,
  deviceName,
  lastOperation
}: AiBridgeInfoProps) => {
  return (
    <Table
      variant="vertical"
      layout="fixed"
      verticalSpacing="sm"
      horizontalSpacing="md"
      withTableBorder
    >
      <Table.Tbody>
        <Table.Tr>
          <Table.Th w={240}>
            <FormattedMessage id="aiBridge.fields.name" />
          </Table.Th>

          <Table.Td>{aiBridge.name}</Table.Td>
        </Table.Tr>

        <Table.Tr>
          <Table.Th>
            <FormattedMessage id="aiBridge.fields.id" />
          </Table.Th>

          <Table.Td>
            <CopyableText text={aiBridge.id}>
              <Code>{aiBridge.id}</Code>
            </CopyableText>
          </Table.Td>
        </Table.Tr>

        <Table.Tr>
          <Table.Th>
            <FormattedMessage id="aiBridge.fields.device" />
          </Table.Th>

          <Table.Td>
            <CopyableText text={aiBridge.device_uuid}>
              {deviceName ? (
                <span>{deviceName}</span>
              ) : (
                <Code>{aiBridge.device_uuid}</Code>
              )}
            </CopyableText>
          </Table.Td>
        </Table.Tr>

        <Table.Tr>
          <Table.Th>
            <FormattedMessage id="aiBridge.fields.path" />
          </Table.Th>

          <Table.Td>
            <CopyableText text={aiBridge.path}>
              <Code>{aiBridge.path}</Code>
            </CopyableText>
          </Table.Td>
        </Table.Tr>

        <Table.Tr>
          <Table.Th>
            <FormattedMessage id="aiBridge.fields.created" />
          </Table.Th>

          <Table.Td>{getFormattedDateWithTime(aiBridge.created_at)}</Table.Td>
        </Table.Tr>

        <Table.Tr>
          <Table.Th>
            <FormattedMessage id="aiBridge.fields.lastOperation" />
          </Table.Th>

          <Table.Td>
            <AiBridgeLastOperation operation={lastOperation} />
          </Table.Td>
        </Table.Tr>
      </Table.Tbody>
    </Table>
  )
}
